import React, { useState, useEffect, useContext } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Invitations from "../components/InvitationsRequests/Invitations";
import InvitationForm from "../components/InvitationsRequests/InvitationForm";
import axios from "axios";
import { UserContext } from "../context/UserContext";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const InvitationsRequestsPage = () => {
  const [invitations, setInvitations] = useState([]);
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    let currUser = localStorage.getItem("user");
    axios
      .get("api/invitation/", {
        headers: {
          "x-auth-token": currUser,
        },
      })
      .then((res) => {
        setInvitations(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    let currUser = localStorage.getItem("user");
    axios
      .get("api/invitation/request", {
        headers: {
          "x-auth-token": currUser,
        },
      })
      .then((res) => {
        setRequests(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div className="homeGrid">
      <InvitationForm requests={requests} invitations={invitations} />
    </div>
  );
};

export default InvitationsRequestsPage;
